var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoadmapBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1279.977,
    height: 198.563,
    viewBox: "0 0 1279.977 198.563",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12041",
    "data-name": "Path 12041",
    d: "M1774,2426H3053.977l-618.086-198.562Z",
    transform: "translate(-1774 -2227.438)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoadmapBottom);
export default __webpack_public_path__ + "static/media/roadmap-bottom.194cb5b758311483d749fddbaeb6722b.svg";
export { ForwardRef as ReactComponent };